import { Text, Icon } from '../../../';
import cx from 'classnames';
import { ComponentProps } from 'react';

import { ReactComponent as ChevronDown } from '@frontend/icons/chevron-down.svg';
import { ReactComponent as ChevronUp } from '@frontend/icons/chevron-up.svg';

import styles from './DropdownButton.module.css';

interface DropdownButtonProps
  extends Pick<ComponentProps<'button'>, 'onClick'> {
  className?: string;
  open?: boolean;
  text?: string;
}

export default function DropdownButton({
  className,
  text,
  open,
  ...otherProps
}: DropdownButtonProps): JSX.Element {
  return (
    <button className={cx(styles['base'], className)} {...otherProps}>
      <div className={styles['inner']}>
        <Text size="small" color="inherit" weight="600">
          {text}
        </Text>
        <Icon component={open ? <ChevronUp /> : <ChevronDown />} size={16} />
      </div>
    </button>
  );
}
